import { render } from "./ConfirmDeleteMenuItem.vue?vue&type=template&id=522135fa"
import script from "./ConfirmDeleteMenuItem.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__